export default __webpack_public_path__ + "static/media/UserIP.a9cb05e8.svg";